import type { Mission } from '../missions.ts'

export const dos: Mission = {
  id: 'dos',
  name: 'U.S. Department of State',
  short: 'State',
  call: "Diplomacy",
  kind: 'department',
  url: 'https://www.state.gov/',
  established: 1789,
  palette: { primary: '#0a314d', secondary: '#062135', accent: '#4574a1' },
  colorSource: { kind: 'site', url: 'https://www.state.gov/' },
  motif: 'globe',
  mission: {
    text: 'To protect and promote U.S. security, prosperity, and democratic values and shape an international environment in which all Americans can thrive.',
    url: 'https://www.state.gov/about',
  },
  fact: {
    text: 'Created as the Department of Foreign Affairs in July 1789, it was renamed the Department of State that September.',
    url: 'https://history.state.gov/about/faq/why-called-state',
  },
  seal: {
    file: 'public/seals/dos.svg',
    source: 'https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_State.svg',
  },
  media: {
    photos: [
        {
          file: "/media/dos-truman-building.jpg",
          small: "/media/dos-truman-building-sm.jpg",
          alt: "The limestone facade of the Harry S Truman Building behind a green lawn, hedges, and a Department of State sign.",
          title: "Harry S Truman Building, Washington, D.C., spring 2024",
          creator: "Linda D. Epstein, U.S. Department of State",
          source: "https://commons.wikimedia.org/wiki/File:Exterior_of_the_United_States_Department_of_State_Harry_S._Truman_Building,_Washington,_D.C.,_spring_2024_-_10.jpg",
          license: "Public domain (U.S. government work)",
        },
        {
          file: "/media/dos-franklin-room.jpg",
          small: "/media/dos-franklin-room-sm.jpg",
          alt: "The Benjamin Franklin State Dining Room set for a working lunch, with crystal chandeliers, marble columns, and long draped tables.",
          title: "Benjamin Franklin Room, Diplomatic Reception Rooms, August 6, 2014",
          creator: "U.S. Department of State",
          source: "https://commons.wikimedia.org/wiki/File:The_Benjamin_Franklin_Room_Is_Set_for_the_U.S.-Africa_Leaders_Summit_Working_Lunch_(14845888812).jpg",
          license: "Public domain (U.S. government work)",
        },
    ],
  },
}
